import React, { useState, useContext, useEffect } from 'react';
import AuthContext from '../../context/auth/authContext';
import AlertContext from '../../context/alert/alertContext';


const Login = (props) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);

  const { setAlert } = alertContext;
  const { login, loginDemo, error, clearErrors, isAuthenticated } = authContext

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push('/');
    }

    if (error === 'Invalid Credentials') {
      setAlert(error, 'danger');
      clearErrors();
    } else if (error) {
      setAlert('Demo login is temporarily unavailable.', 'danger');
      clearErrors();
    }
    // eslint-disable-next-line
  }, [error, isAuthenticated, props.history]);

  const [user, setUser] = useState({
    email: '',
    password: ''
  });

  const { email, password } = user;

  const onChange = e => setUser({ ...user, [e.target.name]: e.target.value })

  const onSubmit = e => {
    e.preventDefault();
    if (email === '' || password === '') {
      setAlert('Please complete all fields to login', 'danger');
    } else {
      login({
        email,
        password
      });
    }
  }

  const onDemoLogin = () => loginDemo();

  return (
    <div className='form-container'>
      <h1>
        Account <span className="text-primary">Login</span>
      </h1>
      <button
        type="button"
        onClick={onDemoLogin}
        className="btn btn-success btn-block"
        style={{ marginBottom: '1rem' }}
      >
        Enter Demo
      </button>
      <p style={{ textAlign: 'center', margin: '0 0 1rem' }}>
        <small>
          Demo environment. Fictional sample data only. Do not enter personal health information.
        </small>
      </p>
      <form onSubmit={onSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={onChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            value={password}
            onChange={onChange}
            required
          />
        </div>
        <input
          type="submit"
          value="Login"
          className="btn btn-dark btn-block" />
      </form>
    </div>
  );
};

export default Login;
